import { createAction, props } from '@ngrx/store';
import { OnboardingFilters, OnboardingLoadParams, OnboardingManagementView } from './direct-onboarding.model';

// Load onboardings actions
export const loadOnboardings = createAction(
  '[Onboarding] Load Onboardings',
  props<{ params?: OnboardingLoadParams }>(),
);

export const loadOnboardingsSuccess = createAction(
  '[Onboarding] Load Onboardings Success',
  props<{
    onboardings: OnboardingManagementView[];
    totalCount: number;
    currentPage: number;
  }>(),
);

export const loadOnboardingsFailure = createAction('[Onboarding] Load Onboardings Failure', props<{ error: string }>());

// Filter actions
export const setFilter = createAction('[Onboarding] Set Filters', props<{ filter: Partial<OnboardingFilters> }>());

export const resetFilter = createAction('[Onboarding] Reset Filters');

export const updateFilter = createAction(
  '[Onboarding] Update Filter',
  props<{ key: keyof OnboardingFilters; value: any }>(),
);

// Pagination actions
export const updatePagination = createAction(
  '[Onboarding] Update Pagination',
  props<{ page: number; pageSize: number }>(),
);

// Sorting actions
export const setSorting = createAction(
  '[Onboarding] Set Sorting',
  props<{ sortBy: string; sortDescending: boolean }>(),
);

// Clear state action
export const clearOnboardings = createAction('[Onboarding] Clear Onboardings');
